//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import signHead from './components/sign-head/index.vue'
import loadListMx from './mixins/load-list.js'
import api from '@/common/urls/url.js';

export default {
  name: 'integral',
  mixins: [loadListMx(api.SIGN.checkInHistory)],
  components: { signHead },
  data() {
    return {

    }
  },
  created() {},
  methods: {
    resetList(list) {
      list.forEach((item) => {
        if (item.receiveType === '1') item.receiveTypeTxt = this.$t('signIn').otherIncentives
        if (item.receiveType === '2') item.receiveTypeTxt = this.$t('signIn').cashBonus
        if (item.receiveType === '3') item.receiveTypeTxt = this.$t('signIn').daySign
        item.moneyType = (() => {
          if (item.receiveType === '2') {
            return '+' + item.receivePrize + this.$t('signIn').size
          } else if (item.receiveType === '3') {
            return '+' + item.receiveIntegral + this.$t('signIn').Integral
          } else {
            return item.receivePrize
          }
        })()
      })
      return list
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/integral.vue